"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const TripAdvisorInfo_1 = __importDefault(require("./TripAdvisorInfo"));
const TripAdvisorRaiting_1 = __importDefault(require("./TripAdvisorRaiting"));
const TripAdvisorReview_1 = __importDefault(require("./TripAdvisorReview"));
const TripAdvisorDetailsWrapper = styled_components_1.default.div(({ theme }) => theme.tripAdvisor.detailsWrapper);
const TripAdvisorDetailsInfo = (0, styled_components_1.default)(TripAdvisorInfo_1.default)(({ theme }) => theme.tripAdvisor.detailsInfo);
const TripAdvisorDetailedReview = styled_components_1.default.div(({ theme }) => theme.tripAdvisor.detailedReview);
const TripAdvisorCurrentRatings = styled_components_1.default.div(({ theme }) => theme.tripAdvisor.currentRatings);
const TripAdvisorDetailsRating = (0, styled_components_1.default)(TripAdvisorRaiting_1.default)(({ theme }) => theme.tripAdvisor.detailsRating);
const TripAdvisorCopyrights = styled_components_1.default.div(({ theme }) => theme.tripAdvisor.copyrights);
const TripAdvisorLogo = (0, styled_components_1.default)(components_common_icon_1.Icon)(({ theme }) => theme.tripAdvisor.logo);
const TA_LOGO = 'https://www.tripadvisor.com/img/cdsi/langs/en/tripadvisor_logo_transp_100x20-15733-5.png';
const useTALogo = () => {
    const [timeStamp, setTimeStamp] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        setTimeStamp(Date.now());
    }, []);
    return timeStamp ? `${TA_LOGO}?${timeStamp}` : null;
};
const TripAdvisorDetails = ({ rating, count, subRatings, reviews, className, }) => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const taLogo = useTALogo();
    return (react_1.default.createElement(TripAdvisorDetailsWrapper, { className: className },
        react_1.default.createElement("div", { className: "-info" },
            typeof rating === 'number' && (react_1.default.createElement("div", { className: "-info-wrapper" },
                react_1.default.createElement(TripAdvisorDetailsInfo, { rating: rating, reviewCount: count, label: t('common:tripAdvisor.label'), size: "medium" }))),
            react_1.default.createElement(TripAdvisorDetailedReview, null,
                react_1.default.createElement("h2", null, t('tripAdvisor.detailedReview.heading')),
                react_1.default.createElement("div", { className: "rating-wrap" }, subRatings &&
                    subRatings.map(({ rating: detailRating, name }, i) => (react_1.default.createElement(TripAdvisorDetailsRating, { key: i, rating: detailRating, label: name, size: "small" })))))),
        react_1.default.createElement(TripAdvisorCurrentRatings, { className: "-current-ratings" },
            react_1.default.createElement("h2", null, t('tripAdvisor.currentRatings.heading')),
            react_1.default.createElement("div", null, (reviews || []).map((review, i) => {
                return react_1.default.createElement(TripAdvisorReview_1.default, Object.assign({ key: i }, review));
            })),
            react_1.default.createElement(TripAdvisorCopyrights, null,
                react_1.default.createElement("span", { className: "-year" }, t('tripAdvisor.copyrights', { year: new Date().getFullYear() })),
                react_1.default.createElement("div", { className: "-powered" },
                    react_1.default.createElement("span", { className: "-powered-text" }, t('tripAdvisor.poweredBy')),
                    taLogo && react_1.default.createElement(TripAdvisorLogo, { name: 'tripadvisor-logo' }))))));
};
exports.default = TripAdvisorDetails;
//# sourceMappingURL=TripAdvisorDetails.js.map